import { useEffect } from 'react';

export const useScene = (id, { data, setSceneData }) => {
	useEffect(() => {
		const { sceneData } = data.levelUp;
		if (!Object.keys(sceneData).length) {
			return;
		}

		if (sceneData.steps[id]) {
			setSceneData({
				text: sceneData.steps[id].message,
				content: sceneData.steps[id].content ?? '',
				author: sceneData.steps[id].hideContact ? '' : sceneData.contact_about,
				authorImage: sceneData.steps[id].contact_image || sceneData.contact_image,
				illustration: sceneData.steps[id].scene_illustration || sceneData.scene_illustration,
			});
		}
	}, [id]);
};
